module.exports = "dist/images/[1]-[2]-[3].c9d3563.png";